export default import.meta.ROLLDOWN_FILE_URL_FRxaeaweTxAIykdx$6Yh_w